import React from 'react';

const EnrolledStudentsTable = ({
  getTableProps,
  getTableBodyProps,
  headerGroups,
  page,
  prepareRow,
  pageIndex,
  pageCount,
  canPreviousPage,
  canNextPage,
  gotoPage,
  previousPage,
  nextPage,
  setPageSize,
  pageSize,
  filteredStudentsLength,
  updatedStudent,
  updatedData,
}) => {
  return (
    <div className="overflow-x-auto p-4">
      <table {...getTableProps()} className="min-w-full mb-4 rounded-lg shadow-md overflow-hidden">
        <thead className="bg-gray-200">
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()} className="px-4 py-2 text-left text-gray-700 font-semibold">
                  {column.render('Header')}
                </th>
              ))}
             </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map(row => {
            prepareRow(row);
            const isSelected = row.original.student_id === updatedStudent;
            const updatedRow = isSelected
              ? {
                  ...row.original,
                  student_name: updatedData.student_name || row.original.student_name || "N/A",
                  gender: updatedData.gender || row.original.gender || "N/A",
                  father_name: updatedData.father_name || row.original.father_name || "N/A",
                  mobile_number1: updatedData.mobile_number1 || row.original.mobile_number1 || "N/A",
                  mobile_number2: updatedData.mobile_number2 || row.original.mobile_number2 || "N/A",
                  email: updatedData.email || row.original.email || "N/A",
                  aadhar_number: updatedData.aadhar_number || row.original.aadhar_number || "N/A",
                  state: updatedData.state || row.original.state || "N/A",
                  district: updatedData.district || row.original.district || "N/A",
                  city: updatedData.city || row.original.city || "N/A",
                  address: updatedData.address || row.original.address || "N/A",
                  pincode: updatedData.pincode || row.original.pincode || "N/A",
                  course: updatedData.course || row.original.course || "N/A",
                  clg_name: updatedData.clg_name || row.original.clg_name || "N/A",
                  program_type: updatedData.program_type || row.original.program_type || "N/A",
                  ug_pg_course: updatedData.ug_pg_course || row.original.ug_pg_course || "N/A",
                  call_status: updatedData.call_status || row.original.call_status || "N/A",
                  remarks: updatedData.remarks || row.original.remarks || "N/A",
                  is_interested: updatedData.is_interested === 'Others' ? updatedData.other_reasons : (updatedData.is_interested || row.original.is_interested || "N/A"),
                  call_back_reason: updatedData.is_interested === "Call Back" ? (updatedData.call_back_reason || row.original.call_back_reason || "N/A") : "N/A",
                  call_duration: updatedData.call_duration || row.original.call_duration || "N/A",
                  is_jee: updatedData.is_jee || row.original.is_jee || "N/A",
                  is_jee2: updatedData.is_jee2 || row.original.is_jee2 || "N/A",
                  updated_date: new Date().toISOString(),
                }
              : row.original;
            
            return (
              <tr
                {...row.getRowProps()}
                className={`transition duration-200 ${isSelected ? 'bg-yellow-100 hover:bg-yellow-200' : 'hover:bg-gray-100'}`}
              >
                {row.cells.map(cell => (
                  <td {...cell.getCellProps()} className="border px-4 py-2">
                    {updatedRow[cell.column.id] || cell.render('Cell')}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="flex justify-between items-center mb-4">
        <span>
          Page {pageIndex + 1} of {pageCount} of {filteredStudentsLength} entries
        </span>
        <div>
          <button onClick={() => gotoPage(0)} disabled={!canPreviousPage} className="px-3 py-1 border rounded">{"<<"}</button>
          <button onClick={previousPage} disabled={!canPreviousPage} className="px-3 py-1 border rounded">{"<"}</button>
          <button onClick={nextPage} disabled={!canNextPage} className="px-3 py-1 border rounded">{">"}</button>
          <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} className="px-3 py-1 border rounded">{">>"}</button>
        </div>
        <select value={pageSize} onChange={e => setPageSize(Number(e.target.value))} className="ml-4 border rounded">
          {[5, 10, 20, 50, 100].map(size => (
            <option key={size} value={size}>Show {size}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default EnrolledStudentsTable;